// extracted by mini-css-extract-plugin
export default {"top":"style_top__w2RDf","profile":"style_profile__X-ihT","image":"style_image__p3smZ","name":"style_name__C+Fad","Shouts":"style_Shouts__J80Y1"};